package com.mps.asc_app.data.places

import com.mps.asc_app.data.places.model.PlaceDetailsResponse
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.serialization.json.Json

class GooglePlacesRepositoryImpl(
    private val http: HttpClient,
    private val apiKey: String
) : GooglePlacesRepository {

    private val json = Json {
        ignoreUnknownKeys = true
        isLenient = true
    }

    override suspend fun fetchPlaceDetails(placeId: String): PlaceDetailsResponse {
        val responseText = http.post("https://placedetails-pdrnyp6vnq-ew.a.run.app") {
            contentType(ContentType.Application.Json)
            setBody(
                mapOf(
                    "data" to mapOf(
                        "placeId" to placeId
                    )
                )
            )
        }.body<String>()

        return json.decodeFromString(responseText)
    }
}